export default __webpack_public_path__ + "static/char-s-06-en-965c0288dafd5cad9baf09fe8b972030.webp";